import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Demo from '../views/Demo.vue'
import HomeV2 from '../views/HomeV2.vue'
import DemoV2 from '../views/DemoV2.vue';

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/demo',
    name: 'demo',
    component: Demo
  },
  {
    path: '/v2',
    name: 'v2',
    component: HomeV2
  },
  {
    path: '/v2demo',
    name: 'v2demo',
    component: DemoV2
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
